import { AntennaIcon, Calendar2OutlineIcon, SatelliteIcon } from 'assets/svgs';
import { GetStartedMetadata } from './types';

export const getStartedMetaDataList: GetStartedMetadata[] = [
  // {
  //   icon: <Plus2OutlineIcon />,
  //   title: 'Register a Spacecraft',
  //   path: '/register-spacecraft',
  //   description: 'Identifying the duration of access and scheduling satellite access',
  //   hoverStyle: 'hover:bg-yellow/[0.08] hover:border-yellow/[0.8]'
  // },
  {
    icon: <SatelliteIcon />,
    title: 'getStarted.step.1.title',
    subtitle: 'getStarted.step.1.subtitle',
    path: '/manage-spacecraft',
    description: 'getStarted.step.1.description',
    hoverStyle: 'hover:bg-black/[0.08] hover:border-black/[0.8]',
    subtitleColor: '#F09E23'
  },
  {
    icon: <AntennaIcon />,
    title: 'getStarted.step.2.title',
    subtitle: 'getStarted.step.2.subtitle',
    path: '/contact-profile',
    description: 'getStarted.step.2.description',
    hoverStyle: 'hover:bg-skyblue/[0.08] hover:border-skyblue/[0.8]',
    subtitleColor: '#00A3FF'
  },
  {
    icon: <Calendar2OutlineIcon />,
    title: 'getStarted.step.3.title',
    subtitle: 'getStarted.step.3.subtitle',
    path: '/schedule-contact',
    description: 'getStarted.step.3.description',
    hoverStyle: 'hover:bg-indigo/[0.08] hover:border-indigo/[0.8]',
    subtitleColor: '#0047FF'
  }
];
